import * as React from 'react';
import * as main from "../../main.module.scss";
import * as target from "./style.module.scss";
export const Target = () => {
  return (
    <section className={target.target}>
      <div className="container">
        <h2 className={main.title}>Для кого вебинар:</h2>
        <div className={target.row}>
          <div className={`${target.col} ${target.purple}`}>
            <h3>Для детей:</h3>
            <ul>
              <li>
                <p>Веселая разминка;</p>
              </li>
              <li>
                <p>Увлекательные игры на внимание;</p>
              </li>
              <li>
                <p>Секреты разгона скорости чтения.</p>
              </li>
            </ul>
          </div>
          <div className={`${target.col} ${target.orange}`}>
            <h3>Для родителей и педагогов:</h3>
            <ul>
              <li>
                <p>Распространенные проблемы при обучении
                  чтению и как их избежать;</p>
              </li>
              <li>
                <p>Комплексный подход при обучении чтению;</p>
              </li>
              <li>
                <p>Как сделать процесс обучения увлекательным.</p>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};
